var exports = {
  "j": "HeroPagination__H5tR7v",
};

module.exports = exports;
